import { render } from "./File.vue?vue&type=template&id=3317361c"
import script from "./File.vue?vue&type=script&lang=ts"
export * from "./File.vue?vue&type=script&lang=ts"
script.render = render

export default script